import React, { useEffect, useCallback, useState, useRef } from 'react';
import { useDropzone } from 'react-dropzone';
import * as yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import DataTablesStageDocument from "./DataTablesStageDocument";
import { uploadeProjectTimelineDocument, destroyProjectTimelineDocument,stageCompleteStatusChangeByOwner ,documentApprovedByApprover} from '../../../actions/projectTimelineActions'
import UpdateModal from './UpdateModal'
import { Modal } from 'react-bootstrap';
import moment from 'moment';
import DisapproveModal from '../Components/ReusableComponent/DisapproveModal'

const ProjectStage = (props) => {

    const childRef = useRef();
    const { user } = useSelector(state => state.auth)
    const dispatch = useDispatch();
    const [files, setFiles] = useState([]);
    const [editFileModal, setEditFileModal] = useState(false)
    const [selectedFileData, setSelectedFileData] = useState(false)
    const [deleteSupportingDocsModal, setDeleteDocumentModal] = useState(false)
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [inputProjectId, setInputProjectId] = useState("");
    const [documentId, setDocumentId] = useState("");
    const [inputStageId, setInputStageId] = useState("");
    const [inputOwnerId, setInputOwnerId] = useState("");
    const [inputApproverId, setInputApproverId] = useState("");
    const [isOwner, setIsOwner] = useState(false);
    const [isInputStageStatus, setIsInputStageStatus] = useState('');
    const [isApprover, setIsApprover] = useState(false);
    const [isTextVisible, setIsTextVisible] = useState(true);
    const [inputProjectClientId, setInputProjectClientId] = useState("");
    const [showRejectModal, setAddRejectModal] = useState(false);
    const [selectedRowData, setselectedRowData] = useState(false);
    const [rejectedReasonData, setRejectedReasonData] = useState([]);
    const [rejectedReasonVisible, setRejectedReasonVisible] = useState(true);

    const validationSchema = yup.object().shape({
        files: yup.array().required("You need to provide a file").min(1, 'You need to provide a file').test("fileSize", "File Size is too large", (value) => {
            console.log(value[0]?.size);
            return value[0]?.size <= 5242880;
        }),
    });

    const { handleSubmit, reset, setValue, formState: { errors } } = useForm({
        mode: "onBlur",
        resolver: yupResolver(validationSchema),
    });

    useEffect(() => {
        // console.log(props, 'timeline stage')
        if (props.data !== '' && props.stage !== '') {
            setInputProjectClientId(props.data?.client_id)
            setInputProjectId(props.data?.id)
            setInputOwnerId(props.stage?.owner_id)
            setInputApproverId(props.stage?.approver_id)
            setInputStageId(props.stage?.id)
            setIsInputStageStatus(props.stage?.status)
            setSelectedFiles(props?.stage?.uploaded_documents || [])
            setRejectedReasonData(props?.stage?.reject_reasons || [])
            setRejectedReasonVisible(true)
        }
    }, [props.data, props.stage, setValue]);

    useEffect(() => {
        if (inputOwnerId || inputApproverId) {
            if (inputOwnerId === user.user_id && inputApproverId === user.user_id) { setIsApprover(true); setIsOwner(true); setIsTextVisible(true)
            } else if (inputOwnerId === user.user_id) {setIsOwner(true); setIsApprover(false); setIsTextVisible(true)
            } else if (inputApproverId === user.user_id) { setIsApprover(true) ;setIsOwner(false); setIsTextVisible(false)
            } else { setIsOwner(false) ;setIsApprover(false) ;setIsTextVisible(false); }
        }
    }, [inputOwnerId, inputProjectClientId, user, inputApproverId ])

    const onDrop = useCallback(acceptedFiles => {
        setFiles([...acceptedFiles])
        setValue('files', acceptedFiles)
    }, [setValue])

    const { getRootProps, getInputProps } = useDropzone({ onDrop });
    const filesDropzon = files.map((file, i) => (
        <li key={file.path}>
            {file.path} - {file.size} bytes  <i onClick={() => removeSelectedFiles(file)} className="fa fa-trash ml-2"></i>
        </li>
    ));

    const onMemberSubmit = async (values, e) => {
        const formData = new FormData();
        formData.append('timeline_stage_id', inputStageId)
        formData.append('project_id', inputProjectId)
        for (let i = 0; i < files.length; i++) {
            formData.append(`documents`, files[i])
        }
        dispatch(uploadeProjectTimelineDocument(formData))
        setFiles([])
        // console.log(values, 'hfhfh')
        //window.location.reload();
        reset();
    }
    const removeSelectedFiles = file => {
        const newFiles = [...files]
        newFiles.splice(newFiles.indexOf(file), 1)
        setFiles(newFiles)
    };
    const deleteTimelineModalShow = data => {
        setDocumentId(data.id)
        setDeleteDocumentModal(true)
    }
    const selectedData = (data) => {
		setSelectedFileData(data);
		setEditFileModal(true);
	};
    
    const handleUpdateStatus = (item, status) => {
        const data = {
            project_id: item.project_id,
            document_id: item.id,
            is_approved: status,
            timeline_stage_id: item.stage_id
        }
        dispatch(documentApprovedByApprover(data))
        //window.location.reload();
    };
    const handleEditModalClose = () => {
        setEditFileModal(false);
        setSelectedFileData(false);
    };
    const deleteSupportingDocsModalClose = () => {
        setDeleteDocumentModal(false)
        setDocumentId()
    }
    const handleDeleteSupportingDocsSubmit = () => {
        const data = {
            project_id: inputProjectId,
            document_id: documentId,
            timeline_stage_id: inputStageId
        }
        dispatch(destroyProjectTimelineDocument(data))
        setDeleteDocumentModal(false)
        setDocumentId()
        // window.location.reload();
    }
    const handelCompleteStage = () => {
        dispatch(stageCompleteStatusChangeByOwner({project_id: inputProjectId, timeline_stage_id: inputStageId}))
    }
    const handleAddReasonClose = () => {
        setAddRejectModal(false);
        setselectedRowData(false);
    };

    const handleReasonShow = (item) => {
        setselectedRowData(item);
        setAddRejectModal(true);
    };
    return (<>
        <div className="col-md-12">
            <div className="card">
                <div className="header">
                    <div className='row'>
                        <div className='col-md-6 col-lg-6 col-sm-12'>
                            <h2>Timeline Documents</h2>
                        </div>
                        <div className='col-md-6 col-lg-6 col-sm-12 text-right'>
                         {isOwner ? <button className='dropdown dropdown-animated scale-left btn px-2 py-2 custum-bg-warning text-white' disabled={isInputStageStatus  === 'Close' ? true : false } onClick={() => handelCompleteStage()}><strong>{isInputStageStatus  === 'Close' ? 'Completed' : 'Complete the stage' } </strong></button> : null }
                        </div>
                    </div>

                </div>
                <div className="body">
                    <div className="row">
                        <div className="col-lg-12 col-md-6 col-sm-12">
                            {isTextVisible ?
                            <form onSubmit={handleSubmit(onMemberSubmit)}>
                                <div className="form-group">
                                    <label htmlFor="job_number" className="control-label">Select Files<span className='text-danger'>*</span></label>
                                    <div className="col-lg-12 col-md-12">
                                        <div className="upload-area">
                                            <div className="header"></div>
                                            <div className="body p-0">
                                                <section className="container">
                                                    <div {...getRootProps({ className: 'dropzone text-center' })}>
                                                        <input {...getInputProps()} {...setValue('files', files)} />
                                                        <p>Drag and drop file or "Click" to browse</p>
                                                    </div>
                                                    <aside>
                                                        <h4>Files</h4>
                                                        <ul>{filesDropzon}</ul>
                                                    </aside>
                                                </section>
                                                {errors.files && (
                                                    <div className="text-danger pt-2">{errors.files.message}</div>
                                                )}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                    <div className='row text-center'>
                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                        <button className='btn mx-2 custom-btn-outline-info px-3 py-2' type='submit'>Submit</button>
                                    </div>
                                    </div>
                                {/* {isOwner ? <button className='btn mx-2 custom-btn-outline-info' disabled={isOwner ? true : false} type='submit'>Update</button> : null} */}
                            </form>
                            : null }
                        </div>
                    </div>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="card card-radius">
                        <div className="header card-header custum-bg-warning rounded">
                            <h2 className="text-white">Documents</h2>
                        </div>
                        <div className="body text-center card-body-shadow">
                            <div className="">
                                <DataTablesStageDocument 
                                ref={childRef} 
                                isApprover={isApprover} 
                                isOwner={isOwner} 
                                data={selectedFiles} 
                                project_id={inputProjectId} 
                                stage_id={inputStageId} 
                                openModal={selectedData} 
                                openModalDelete={deleteTimelineModalShow} 
                                changeStatus={handleUpdateStatus} 
                                openRejectModal={handleReasonShow}
                                mode='edit'/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {rejectedReasonVisible ?
                    <>
                        <div className='row px-2 pb-3 clearfix'>
                            <h5>Rejected Reasons</h5>
                            <div className='col-md-12 col-lg-12 col-sm-12'>
                                {rejectedReasonData && rejectedReasonData.map((reason, index) => (
                                    <p key={index}>{reason.rejection_reason} : <span>{moment(reason.rejection_date).format('DD-MM-YYYY hh:mm')}</span></p>
                                ))}
                            </div>
                        </div>
                    </> 
                : null}
        </div>
        
        <UpdateModal
            open={editFileModal}
            close={handleEditModalClose}
            data={selectedFileData}
        />
        <DisapproveModal
                component={'TimelineStageDocument'}
                open={showRejectModal}
                close={handleAddReasonClose}
                data={selectedRowData}
            />
        <Modal show={deleteSupportingDocsModal} onHide={deleteSupportingDocsModalClose} className="modal fade modal-bx-info" id="exampleModalLong" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
            <div className="modal-dialog  m-0" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title text-danger">Delete Document From Server</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={deleteSupportingDocsModalClose}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        Are you sure to delete?
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn button" data-dismiss="modal" onClick={handleDeleteSupportingDocsSubmit}>Confirm</button>
                        <button type="button" className="btn btn-danger py-2 px-3 rounded-lg" data-dismiss="modal" onClick={deleteSupportingDocsModalClose}>Close</button>
                    </div>
                </div>
            </div>
        </Modal>
    </>
    )
}

export default ProjectStage;